import React from 'react';
import StaticImage from '../StaticImage';
import {
  BoldParagraph,
  CircleList,
  CircleListItem,
  GatedBlockContainer,
  GradientBlock,
  TextBlock,
  TryItBlockBottom,
  TryItBlockTop,
  TryItTextBottom,
  TryItTextTop,
} from './GatedBlock.styled';
import UpgradeTrialButton from './UpgradeTrialButton/UpgradeTrialButton';

const laptopImage = '/img/laptop-img.jpg';

const FreeTrialGatedBlock = ({ isHigher = false, recordName }) => (
  <GatedBlockContainer $isHigher={isHigher}>
    <GradientBlock />
    <TryItBlockTop>
      <TryItTextTop>
        Don&apos;t have access to the full content yet?
      </TryItTextTop>
      <UpgradeTrialButton recordName={recordName} />
    </TryItBlockTop>
    <TextBlock>
      <BoldParagraph>
        Military Periscope gives you easy-to-use, integrated, open-source
        intelligence on…
      </BoldParagraph>
      <CircleList>
        <CircleListItem>
          More than <b>7,500 weapons systems</b> and platforms
        </CircleListItem>
        <CircleListItem>
          Nearly every country&#39;s <b>armed forces</b>
        </CircleListItem>
        <CircleListItem>
          <b>Militant organizations</b>
        </CircleListItem>
      </CircleList>
    </TextBlock>
    <TryItBlockBottom>
      <StaticImage
        width={802}
        height={445}
        alt='laptop image'
        src={laptopImage}
        quality={100}
      />
      <TryItTextBottom>Try Military Periscope full access</TryItTextBottom>
      <UpgradeTrialButton recordName={recordName} />
    </TryItBlockBottom>
  </GatedBlockContainer>
);

export default FreeTrialGatedBlock;
